module.exports = __webpack_public_path__ + "img/badge_delega_consulenza.bc940a82.jpg";